import { LeafBreadcrumbs } from "./breadcrumbs.component.js";
customElements.define("leaf-breadcrumbs", LeafBreadcrumbs);
export {
  LeafBreadcrumbs
};
//# sourceMappingURL=breadcrumbs.js.map
